import { render, staticRenderFns } from "./customer-filter.vue?vue&type=template&id=634a7e26&scoped=true&"
import script from "./customer-filter.vue?vue&type=script&lang=ts&"
export * from "./customer-filter.vue?vue&type=script&lang=ts&"
import style0 from "./customer-filter.vue?vue&type=style&index=0&id=634a7e26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634a7e26",
  null
  
)

export default component.exports